/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tooltip_FulfillmentInputs */

const en_tooltip_fulfillment = /** @type {(inputs: Tooltip_FulfillmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose how the buyer will receive their purchase. Digital downloads and scheduled services have special automated flows.`)
};

const id_tooltip_fulfillment = /** @type {(inputs: Tooltip_FulfillmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih bagaimana pembeli akan menerima pembelian mereka. Unduhan digital dan layanan terjadwal memiliki alur otomatis khusus.`)
};

/** @type {(inputs: Tooltip_FulfillmentInputs) => LocalizedString} */
const es_tooltip_fulfillment = en_tooltip_fulfillment;

/** @type {(inputs: Tooltip_FulfillmentInputs) => LocalizedString} */
const fr_tooltip_fulfillment = en_tooltip_fulfillment;

/** @type {(inputs: Tooltip_FulfillmentInputs) => LocalizedString} */
const de_tooltip_fulfillment = en_tooltip_fulfillment;

/** @type {(inputs: Tooltip_FulfillmentInputs) => LocalizedString} */
const ja_tooltip_fulfillment = en_tooltip_fulfillment;

/** @type {(inputs: Tooltip_FulfillmentInputs) => LocalizedString} */
const zh_tooltip_fulfillment = en_tooltip_fulfillment;

/** @type {(inputs: Tooltip_FulfillmentInputs) => LocalizedString} */
const ar_tooltip_fulfillment = en_tooltip_fulfillment;

/** @type {(inputs: Tooltip_FulfillmentInputs) => LocalizedString} */
const it_tooltip_fulfillment = en_tooltip_fulfillment;

/** @type {(inputs: Tooltip_FulfillmentInputs) => LocalizedString} */
const ru_tooltip_fulfillment = en_tooltip_fulfillment;

/** @type {(inputs: Tooltip_FulfillmentInputs) => LocalizedString} */
const pt_tooltip_fulfillment = en_tooltip_fulfillment;

/** @type {(inputs: Tooltip_FulfillmentInputs) => LocalizedString} */
const ko_tooltip_fulfillment = en_tooltip_fulfillment;

/**
* | output |
* | --- |
* | "Choose how the buyer will receive their purchase. Digital downloads and scheduled services have special automated flows." |
*
* @param {Tooltip_FulfillmentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tooltip_fulfillment = /** @type {((inputs?: Tooltip_FulfillmentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tooltip_FulfillmentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tooltip_fulfillment(inputs)
	if (locale === "es") return es_tooltip_fulfillment(inputs)
	if (locale === "fr") return fr_tooltip_fulfillment(inputs)
	if (locale === "de") return de_tooltip_fulfillment(inputs)
	if (locale === "ja") return ja_tooltip_fulfillment(inputs)
	if (locale === "zh") return zh_tooltip_fulfillment(inputs)
	if (locale === "ar") return ar_tooltip_fulfillment(inputs)
	if (locale === "id") return id_tooltip_fulfillment(inputs)
	if (locale === "it") return it_tooltip_fulfillment(inputs)
	if (locale === "ru") return ru_tooltip_fulfillment(inputs)
	if (locale === "pt") return pt_tooltip_fulfillment(inputs)
	return ko_tooltip_fulfillment(inputs)
});